import { request_list, request_header } from '@/commons/hpod';
import configs from '@/configs';
import Vue from 'vue';

// initial state
const state = {
    loading: false,
    data: {
        daily_stats: [],
        summary_by_customer: [],
        total_summary: {},
        chart_data: []
    }
};

// getters
const getters = {};

// actions
const actions = {
    getStatistics({ commit }, params) {
        commit("setLoading", { loading: true });
        
        const header = {
            headers: request_header(this.state.authentication.token)
        };
        
        let queryParams = new URLSearchParams();
        if (params.from_date) queryParams.append('from_date', params.from_date);
        if (params.to_date) queryParams.append('to_date', params.to_date);
        if (params.customer_id) queryParams.append('customer_id', params.customer_id);
        
        const url = `${configs.SYSTEM_TYPE == 'order' ? configs.API : configs.API_DEPOSIT}/admin/api/dashboard/bigpackage-statistics/?${queryParams.toString()}`;
        
        Vue.http.get(url, header).then(function (response) {
            if (response.data && response.data.status === 200) {
                commit('setStatistics', response.data.data);
            } else {
                commit('setStatistics', response.data);
            }
            commit("setLoading", { loading: false });
        }, function (error) {
            commit("setLoading", { loading: false });
        });
    }
};

// mutations
const mutations = {
    setStatistics(state, data) {
        state.data = data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};